// @ts-strict-ignore
import { Image } from '@gassan-ui'
import { cn } from '@lib/cn'
import { getKontentImage } from '@lib/kontent'
import { AssetsElement } from '@lib/kontent/models/Elements'
import { FC, HTMLAttributes } from 'react'

type Props = HTMLAttributes<HTMLElement> & {
  mobileImage: AssetsElement
  desktopImage: AssetsElement
}

const ImageBanner: FC<Props> = ({ mobileImage, desktopImage, className }) => {
  return (
    <section
      className={cn(
        'relative mx-0 my-[10vh] flex h-[25vh] items-center justify-center text-center',
        className,
      )}
    >
      <div className="absolute inset-0 -z-[1] h-full w-full">
        <Image
          className="z-[-1] h-full w-full"
          placeholder={getKontentImage(mobileImage.value[0].url, { width: 50 })}
          sources={[
            getKontentImage(mobileImage.value[0].url, { width: 600 }),
            getKontentImage(desktopImage.value[0].url, { width: 2000 }),
            getKontentImage(desktopImage.value[0].url, { width: 2000 }),
          ]}
          alt={mobileImage.value[0].description}
        />
      </div>
    </section>
  )
}

export default ImageBanner
